(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('truckService', truckService);

    /* @ngInject */
    function truckService(coreService, $q, $odata, $odataresource, config, currentUser) {
        var service = {
            getODataResource: getODataResource,
            getCompanyTrucksODataResource: getCompanyTrucksODataResource,
            getTableConfig: getTableConfig,
            getAllTrucks: getAllTrucks,
            getAllTruckVins: getAllTruckVins,
            getTruck: getTruck,
            updateTruckLocation: updateTruckLocation,
            getCompanyTrucksByUserId: getCompanyTrucksByUserId,
            getModalOptions: getModalOptions,
            submitTruckRequest: submitTruckRequest
        };

        activate();

        return service;

        function activate() {
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/truck/modal/request.modal.html',
                controllerAs: 'vm'
            };
        }

        function getTableConfig() {
            return {
                columns: [
                    {
                        id: 'ShortVIN',
                        displayName: 'ShortVIN',
                        ODataKey: 'Truck/ShortVIN',
                        type: 'guid', 
                        tooltip: {
                            placement: 'right',
                            text: function (row) {
                                return row.VIN;
                            }
                        }
                    },
                    {
                        id: 'Model',
                        displayName: 'Model',
                        ODataKey: 'Truck/Model',
                        type: 'guid'                       
                    },
                    {
                        id: 'ModelYear',
                        displayName: 'Model Year',
                        ODataKey: 'Truck/ModelYear',
                        type: 'guid'
                    },
                    {
                        id: 'Name',
                        displayName: 'Company',
                        ODataKey: 'Customer/Name',
                        type: 'match'
                    },
                    {
                        id: 'Address',
                        displayName: 'Address',
                        ODataKey: 'Customer/Address1',
                        type: 'match'
                    }
                ],
                actions: []
            };
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/Trucks',
                {},
                {},
                {
                    odatakey: 'TruckId',
                    isodatav4: true
                });
        }

        function getCompanyTrucksODataResource() {
            return $odataresource(config.apiUrl + 'odata/CompanyTrucks',
                {},
                {},
                {
                    odatakey: 'TruckCustomerTieId',
                    isodatav4: true
                });
        }

        function getTruck(vin){
            var url = 'pending/user/smartTruck/' + vin + '/verify';
            return coreService.httpAccountsGet(url);
        }

        function updateTruckLocation(truckId, customerId, verify) {
            return coreService.httpAccountsPost('customer/' + customerId + '/truck/' + truckId + '/verify/' + verify);
        }

        function submitTruckRequest(request) {
            return coreService.httpAccountsPost('truck/request', request);
        }

        //function getCompanyTrucksByUserId(userId) {
        //    var url = 'truck/getByCompany/' + userId;
        //    return coreService.httpAccountsGet(url);
        //}

        function getCompanyTrucksByUserId(tableState) {
            var query = service.getCompanyTrucksODataResource().odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject, getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ?
                tableState.sort : { predicate: 'Truck/ShortVIN', reverse: true };
            coreService.processODataSort(query, tableState.sort);
          
            return query
                .expand('Truck')
                .expand('Customer')
                .expand('Customer', 'Country')
                .expand('Customer', 'State')
                .withInlineCount()
                .query()
                .$promise.then(function (results) {
                    var mapped = results.map(function (truck) {
                        return {
                            TruckId: truck.Truck.TruckId,
                            ShortVIN: truck.Truck.ShortVIN,
                            VIN: truck.Truck.VIN,
                            Model: truck.Truck.Model == null ? 'N/A' : truck.Truck.Model,
                            ModelYear: truck.Truck.ModelYear == null ? 'N/A' : truck.Truck.ModelYear,
                            Name: truck.Customer.Name,
                            Address: truck.Customer.Address1 + ', ' + truck.Customer.City + ', ' +
                                truck.Customer.State.StateCode + ', ' + truck.Customer.ZIPCode + ', ' +
                                truck.Customer.Country.CountryCodeISO3,
                            Customer: {
                                CustomerId: truck.Customer.CustomerId,
                                Name: truck.Customer.Name,
                                Address1: truck.Customer.Address1,
                                Address2: truck.Customer.Address2,
                                City: truck.Customer.City,
                                StateCode: truck.Customer.State.StateCode,
                                ZipCode: truck.Customer.ZIPCode,
                                CountryCode: truck.Customer.Country.CountryCodeISO3
                            }
                        };
                    });

                    mapped.count = results.count;

                    return mapped;
                       
                });  
        }        

        function getAllTrucks(searchTerm, page, count) {
            var query = service.getODataResource().odata();

            coreService.processODataPage(query, { start: (page * count), number: count });

            if (!searchTerm) {
                query.filter(new $odata.Func('contains',
                    new $odata.Property('VIN'), searchTerm));
            }           

            query.filter('Deleted', false);

            return query                
                .withInlineCount()
                .take(10)
                .query()                
                .$promise;    
        }

        function getAllTruckVins(searchTerm, page, count) {
            var query = service.getODataResource().odata();

            coreService.processODataPage(query, { start: (page * count), number: count });

            if (!!searchTerm) {
                query.filter(new $odata.Func('contains',
                    new $odata.Property('VIN'), searchTerm));
            }

            query.filter('Deleted', false);

            return query
                .select('ShortVIN')
                .withInlineCount()
                .take(10)
                .query()
                .$promise;    
        }
    }
})();
